import styles from './PaginatedModal.module.scss'

import React, { useEffect, useState } from 'react'

import Modal from 'Components/Modal/NewModal.js'

const PaginatedModal = ({
  className,
  isOpen,
  id,
  containerClassName,
  modalContent,
  onClose,
  activeIndex,
  onLeft,
  onRight,
  inverseTheme,
}) => {
  const [contentIndex, setContentIndex] = useState(activeIndex <= modalContent?.length - 1 ? activeIndex : 0)

  useEffect(() => {
    if (activeIndex >= 0 && activeIndex <= modalContent?.length - 1) setContentIndex(activeIndex)
  }, [activeIndex])

  const handlePaginationLeft = () => {
    if (onLeft) onLeft()
    else {
      let newContentIndex = contentIndex - 1
      if (newContentIndex < 0) newContentIndex = modalContent?.length - 1
      setContentIndex(newContentIndex)
    }
  }

  const handlePaginationRight = () => {
    if (onRight) onRight()
    let newContentIndex = contentIndex + 1
    if (newContentIndex == modalContent?.length) newContentIndex = 0
    setContentIndex(newContentIndex)
  }

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      className={className}
      containerClassName={containerClassName}
      onClose={onClose}
      showPagination
      onPaginationLeft={handlePaginationLeft}
      onPaginationRight={handlePaginationRight}
      inverseTheme
    >
      <div className={styles.paginatedModalContentContainer}>{modalContent && modalContent[contentIndex]}</div>
    </Modal>
  )
}

export default PaginatedModal
